export default "__VITE_ASSET__ae0c8eae__"